import React from "react";
import Chart from "react-apexcharts";

const SparklineChart1 = ({ data }) => {
  const uniqueSectorCount = new Set(data.map(item => item.sector)).size;
  // const sparklineData = Array.from({ length: uniqueSectorCount }, (_, i) => i + 1);
  const labels = [...Array(uniqueSectorCount).keys()].map(n => `Sector ${n + 1}`);
  const sparklineData = [8, 6, 1, 4, 7, 13, 5, 5, 1, 2, 6, 8, 11];
  const spark3 = {
    chart: {
      id: "sparkline3",
      group: "sparklines3",
      type: "area",
      height: 100,
      sparkline: {
        enabled: true,
      },
    },
    stroke: {
      curve: "straight",
    },
    fill: {
      opacity: 1,
    },
    series: [
      {
        name: "Total Sector",
        data: sparklineData,
      },
    ],
    labels,
    xaxis: {
      type: "category",
    },
    yaxis: {
      min: 0,
    },
    colors: ["#fff"],
    title: {
      text: "Total Sector",
      offsetX: 30,
      style: {
        fontSize: "24px",
        color: "#fff",
        cssClass: "apexcharts-yaxis-title",
      },
    },
    subtitle: {
      text: `${uniqueSectorCount}`,
      offsetX: 30,
      style: {
        fontSize: "14px",
        color: "#fff",
        cssClass: "apexcharts-yaxis-title",
      },
    },
  };

  return (
    <div>
      <Chart
        options={spark3}
        series={spark3.series}
        type="area"
        width={"100%"}
        height={97}
      />
    </div>
  );
};

export default SparklineChart1;
